import styled from "styled-components";

export const CreateQuickPostContainer = styled.div`
  background-color: #fff;
  height: 100%;
  width: 100%;
  padding: var(--spacing-xxl, 40px);
  padding-bottom: 95px;
  display: flex;
  justify-content: center;
  align-items: center;

  .quick-post-form {
    padding: var(--spacing-xxl, 40px) 56px;
    display: flex;
    flex-direction: column;
    gap: var(--spacing-xxl, 40px);
    width: 100%;

    /* Laptop screens (13"-16" MacBooks typically 600-900px height) */
    @media screen and (max-height: 900px) {
      gap: 20px;
      padding: 0 40px;
    }

    &__header {
      display: flex;
      align-items: center;
      gap: 16px;

      h1 {
        font-family: var(--font-family-website, Sora);
        font-size: var(--font-size-xxxl, 42px);
        line-height: var(--font-line-height-xxxl, 56px);
      }
    }

    &__description {
      font-size: var(--font-size-sm, 14px);
      line-height: var(--font-line-height-sm, 20px);
      margin-top: 12px;
    }

    .input-title-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .title-input {
      width: 100%;
    }

    .body-input {
      height: 100% !important;
    }
  }

  .file-upload {
    padding-right: 32px;
    display: flex;
    width: 100%;
    flex-direction: column;
    justify-content: center;
    height: 100%;

    &.hidden {
      display: none;
    }

    #droppane {
      margin-top: 16px;
      width: 100%;
      z-index: 0; // required for the file picker to be below the Create button footer
      #filepicker {
        min-height: 280px;

        .fsp-picker {
          background: transparent;
        }
        .fsp-modal {
          background: #fff;
          display: flex;
          flex-direction: column;
          gap: 10px;
          align-items: center;
          padding: 10px;
          border-radius: 16px;
          transition: none;
          border: 1px solid #d0e0f9;
          box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);

          .fsp-modal__sidebar {
            position: relative;
            width: auto;
            background: #fff;
            display: flex;
            transition: none;
            flex-shrink: 0;
            top: 0;

            :hover {
              box-shadow: none;
            }
            &:hover {
              border-radius: 12px;
            }

            .fsp-source-list {
              display: flex;
              flex-direction: row;
              width: auto;
              justify-content: center;
              background: #f8f8f8;
              box-shadow: inset 0 0 0 1px #dddddd;
              border-radius: 10px;

              .fsp-source-list__item {
                width: auto;
                padding: 10px 15px;
                border-radius: 10px;
                gap: 10px;

                .fsp-source-list__label {
                  display: none;
                }

                .fsp-source-list__logout {
                  position: relative;
                  top: auto;
                  right: auto;
                  transform: none;
                  color: #19191b;
                }

                .fsp-source-list__icon {
                  margin: 0;
                  width: 24px;
                  height: 24px;

                  &.fsp-icon--local_file_system {
                    background-image: none;
                    background-color: #19191b;
                    mask: url("/src/images/fspicker/laptop.svg") center center
                      no-repeat;
                    mask-size: contain;
                    width: 24px;
                    height: 24px;
                  }
                  &.fsp-icon--unsplash {
                    background: url("/src/images/fspicker/unsplash.svg")
                      no-repeat;
                    border-radius: 0;
                  }
                  &.fsp-icon--url {
                    background-image: none;
                    background-color: #19191b;
                    mask: url("/src/images/fspicker/link.svg") center center
                      no-repeat;
                    mask-size: contain;
                    width: 24px;
                    height: 24px;
                  }
                  &.fsp-icon--googledrive {
                    background: url("/src/images/fspicker/gdrive.svg") no-repeat;
                  }
                  &.fsp-icon--onedrive {
                    background: url("/src/images/fspicker/onedrive.svg")
                      no-repeat;
                  }
                  &.fsp-icon--box {
                    background: url("/src/images/fspicker/box.svg") no-repeat;
                  }
                  &.fsp-icon--dropbox {
                    background: url("/src/images/fspicker/dropbox.svg")
                      no-repeat;
                  }
                }

                :hover {
                  background: #dddddd;

                  .fsp-source-list__icon {
                    &.fsp-icon--local_file_system,
                    &.fsp-icon--url {
                      background-color: #19191b;
                    }
                  }
                }

                &--active {
                  background: #0d3d87;
                  .fsp-source-list__icon {
                    &.fsp-icon--local_file_system,
                    &.fsp-icon--url {
                      background-color: #fff;
                    }
                    &.fsp-icon--unsplash {
                      background: url("/src/images/fspicker/unsplash-white.svg")
                        no-repeat;
                    }
                  }

                  .fsp-source-list__logout {
                    color: #fff;
                  }

                  :hover {
                    background: #19191b;

                    .fsp-source-list__icon {
                      &.fsp-icon--local_file_system,
                      &.fsp-icon--url {
                        background-color: #fff;
                      }
                      &.fsp-icon--unsplash {
                        background: url("/src/images/fspicker/unsplash-white.svg")
                          no-repeat;
                      }
                    }
                  }
                }
              }
              @media screen and (max-width: 767px) {
                .fsp-source-list__item {
                  padding: 10px 12px;
                }
              }
            }
          }

          .fsp-modal__body {
            position: relative;
            width: 100%;
            height: 100%;
            border-radius: 10px;
            padding-bottom: 0;
            background-color: #f8f8f8;
            .fsp-header {
              display: none;
            }
            .fsp-content {
              border-radius: 10px;
              height: 100%;
              .fsp-drop-area-container {
                padding: 0;

                .fsp-drop-area {
                  border: 3px dashed #73a3ed;
                  background: #e8f0fc;
                }
              }

              .fsp-content-scroll {
                overflow: auto;
              }

              .fsp-summary {
                padding: 0;

                .fsp-summary__header {
                  display: none;
                }

                .fsp-summary__body {
                  height: 214px;

                  &.fsp-summary__has-actions {
                    height: 145px;

                    @media screen and (max-width: 767px) {
                      height: 221px;
                    }
                  }
                }
              }

              /*** Custom: Unsplash ***/

              .fsp-unsplash-source {
                height: 214px;
              }

              .fsp-unsplash-source__container {
                padding: 20px;

                .fsp-unsplash-title {
                  margin-bottom: 20px;
                  font-size: 16px;
                  line-height: 24px;
                  font-weight: bold;

                  .fsp-unsplash-subtitle {
                    font-size: 12px;
                    line-height: 16px;
                    color: #a3a3a4;
                    font-weight: normal;
                    margin: 0;
                  }
                }

                .fsp-unsplash-logo {
                  display: none;
                }

                &.fsp-unsplash-is_filled {
                  padding: 10px;
                }
              }

              /*** Custom: Cloud Drive ***/

              .fsp-cloud__container {
                .fsp-icon {
                  display: none;
                }

                .fsp-text__subheader {
                  font-size: 12px;
                  line-height: 16px;
                  color: #a3a3a4;
                }

                .fsp-source-auth__el {
                  margin-bottom: 10px;
                  font-size: 16px;
                  line-height: 24px;
                  font-weight: bold;

                  &.fsp-text__title {
                    margin: 0;
                  }
                }

                .fsp-button--authgoogle {
                  margin-bottom: 10px;
                }

                .fsp-cloud__files-container {
                  height: 214px;
                }
              }
            }
            .fsp-footer {
              .fsp-footer__nav {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
              }
              .fsp-footer__nav--left {
                display: none;
              }
              .fsp-footer__nav--center,
              .fsp-footer__nav--right {
                line-height: unset;
                position: unset;
                float: none;

                div {
                  display: flex;
                  gap: 5px;
                }
                .fsp-button.fsp-button--cancel {
                  display: none;
                }
                .fsp-button {
                  border-radius: 8px;
                  font-size: 14px;
                  padding-left: 12px;
                  padding-right: 12px;
                  height: 32px;
                  line-height: 30px;
                  font-family: "Lato", sans-serif;
                  font-weight: bold;

                  > span {
                    height: 100%;
                    display: flex;
                    align-items: center;

                    .fsp-badge {
                    }
                  }
                }
              }
            }
            .fsp-select-labels {
              background-image: none;
              padding: 0;

              .fsp-drop-area__title.fsp-text__title {
                margin: 0;
              }
              .fsp-drop-area__subtitle.fsp-text__subheader {
                margin: 0;
              }

              :after {
                margin: 0;
              }
            }
          }
        }
      }
    }
  }

  .field-constraints {
    color: var(--color-gray-800, #363639);
    font-size: 12px;
    line-height: 16px;
  }
`;
